import axios from 'axios';
import {
  IModelDetails,
  IModelViewDetails,
  ItemInstance,
  NamedIModelDetails,
} from '../types';

/**
 * Get a list of iModels
 *
 * @param {string} projectId Project id to get iModels for
 * @returns {Promise} List of {@link ItemInstance}
 */
export async function fetchIModels(projectId: string): Promise<ItemInstance[]> {
  return (await axios.get<ItemInstance[]>(`api/project/${projectId}/imodels`))
    .data;
}

/**
 * Get a list of changesets
 *
 * @param {string} iModelId iModel id to get changesets for
 * @returns {Promise} List of {@link ItemInstance}
 */
export async function fetchIModelChangesets(
  imodelId: string
): Promise<ItemInstance[]> {
  return (await axios.get<ItemInstance[]>(`api/imodel/${imodelId}/changesets`))
    .data;
}

/**
 * Get a list of iModel views
 *
 * @param {string} projectId Project ID to get iModel views for
 * @param {string} iModelId iModel ID to get views for
 * @returns {Promise} List of {@link ItemInstance}
 */
export async function fetchIModelViews(
  projectId: string,
  imodelId: string
): Promise<ItemInstance[]> {
  return (
    await axios.get<ItemInstance[]>(
      `api/project/${projectId}/imodel/${imodelId}/savedViews`
    )
  ).data;
}

/**
 * Get imodel's details
 *
 * @param {string} imodelId imodel ID to get details for
 * @returns {Promise} Details {@link IModelDetails}
 */
export async function fetchIModelDetails(
  imodelId: string
): Promise<IModelDetails> {
  return (await axios.get<IModelDetails>(`/api/imodel/${imodelId}`)).data;
}

/**
 * Get an imodel's named version's details
 *
 * @param {string} imodelId imodel ID
 * @param {string} changeSetId changeSet ID
 * @returns {Promise} Details {@link NamedIModelDetails}
 */
export async function fetchNamedVersionDetails(
  imodelId: string,
  changeSetId: string
): Promise<NamedIModelDetails | undefined> {
  return (
    await axios.get<NamedIModelDetails>(
      `/api/imodel/${imodelId}/changeset/${changeSetId}`
    )
  ).data;
}

/**
 * Get an imodel view's details
 *
 * @param {string} projectId project ID
 * @param {string} imodelId imodel ID
 * @param {string} savedViewId view ID
 * @returns {Promise} Details {@link NamedIModelDetails}
 */
export async function fetchIModelViewDetails(
  projectId: string,
  imodelId: string,
  savedViewId: string
): Promise<IModelViewDetails> {
  return (
    await axios.get<IModelViewDetails>(
      `/api/project/${projectId}/imodel/${imodelId}/savedViews/${savedViewId}`
    )
  ).data;
}
